import { EntradaProdutoRepository } from "../repository/entrada_produto_repository";

export class EntradaProdutoService {
	constructor() {
		this.entradaProdutoRepository = new EntradaProdutoRepository();
	}

	async save(data) {
		return await this.entradaProdutoRepository.save(data);
	}

	async update(data) {
		return await this.entradaProdutoRepository.update(data);
	}

	async remover(id) {
		return await this.entradaProdutoRepository.remover(id);
	}

	async getHistorico(id) {
		return await this.entradaProdutoRepository.getHistorico(id);
	}

	async getRecepcao(unidadeDistribuidoraId, data, page, limit, search) {
		return await this.entradaProdutoRepository.getRecepcao(unidadeDistribuidoraId, data, page, limit, search);
	}

	async getConsolidado(unidadeDistribuidoraId, data, page, limit, search) {
		return await this.entradaProdutoRepository.getConsolidado(unidadeDistribuidoraId, data, page, limit, search);
	}

	async getById(id) {
		return await this.entradaProdutoRepository.getById(id);
	}

	async confirmarEntrada(id) {
		return await this.entradaProdutoRepository.confirmarEntrada(id);
	}

	async negarEntrada(id) {
		return await this.entradaProdutoRepository.negarEntrada(id);
	}

	async salvarQualidades(id, qualidades) {
		return await this.entradaProdutoRepository.salvarQualidades(id, qualidades);
	}

	async changeVisibility(id) {
		return await this.entradaProdutoRepository.changeVisibility(id);
	}

	async getProdutosEntrada(unidadeDistribuidoraId) {
		return await this.entradaProdutoRepository.getProdutosEntrada(unidadeDistribuidoraId);
	}

	async getQualidades() {
		return await this.entradaProdutoRepository.getQualidades();
	}

	async getLotesConsolidados(unidadeDistribuidoraId, produtoId) {
		return await this.entradaProdutoRepository.getLotesConsolidados(unidadeDistribuidoraId, produtoId);
	}

	async getFornecedoresPorProduto(unidadeDistribuidoraId, cultivoId) {
		return await this.entradaProdutoRepository.getFornecedoresPorProduto(unidadeDistribuidoraId, cultivoId);
	}
}
